<template>
    <div class="flight_search_item_wrappper">
        <div class="flight_search_items multi_city">
            <div class="multi_city_flight_lists w-100">
                <div v-for='(itinerarie, index) in item.itineraries' class="itineraries">
                    <div v-for='(segment, index) in itinerarie.segments' class="flight_multis_area_wrapper">
                        <div class="flight_search_left">
                            <div class="flight_logo">
                                <div :class="'flight-image i-' + segment.carrierCode.toString().toLowerCase()"
                                    v-tooltip.top="result.airlines[segment.carrierCode][$i18n.locale]">
                                </div>
                                <p class="mt-2">{{ segment.carrierCode }}{{ segment.number }}</p>
                            </div>
                            <div class="flight_search_destination">
                                <h3>{{ segment.departure.iataCode }}
                                </h3>
                                <p class="time">
                                    {{ getFormattedTime(segment.departure.at) }}
                                </p>
                                <p class="date">
                                    {{ getFormattedDate(segment.departure.at) }}
                                </p>
                                <h6>{{ segment.departure.airportName }}</h6>
                            </div>
                        </div>
                        <div class="flight_right_arrow">
                            <img :src="require(`@/assets/img/icons/right_arrow.png`)" alt="img" />
                            <h6>{{ getFormattedDate(segment.departure.at) }}</h6>
                            <p>{{ convertDuration(segment.duration) }}</p>
                        </div>
                        <div class="flight_search_middel">
                            <div class="flight_search_destination">
                                <h3>{{ segment.arrival.iataCode }}
                                </h3>
                                <p class="time">
                                    {{ getFormattedTime(segment.arrival.at) }}
                                </p>
                                <p class="date">
                                    {{ getFormattedDate(segment.arrival.at) }}
                                </p>
                                <h6>{{ segment.arrival.airportName }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!is_selected" class="dduKua">
                    <span>
                        {{ $t('seats') }} : {{ item.numberOfBookableSeats }}
                    </span>
                </div>
            </div>
            <div v-if="!is_selected" class="flight_search_right">
                <h3 v-if="is_self_paying == 1 || user_type == 'null'" class="price">
                    {{ get_total_price_with_markup(item.travelerPricings).toFixed(2) }}
                    <span class="primary-color">{{ $t('SAR') }}</span>
                </h3>
                <div v-if="allowed_to_make_exception == 1
                    && get_price_with_markup(item.travelerPricings[0].price.total) > max_ticket_price"
                    class="arrow-ribbone-right bg-info">
                    {{ $t('need approval') }}
                </div>
                <a @click="select_flight" class="btn btn_theme btn_sm select-flight">
                    <span>
                        {{
                            allowed_to_make_exception == 1
                                && get_price_with_markup(item.travelerPricings[0].price.total) > max_ticket_price
                                ? $t('request approval')
                                : $t('Select Flight')
                        }}
                    </span>
                </a>
            </div>
            <div v-else class="flight_search_right">
                <a @click="change_flight" class="btn btn_theme btn_sm change-flight">
                    <span>{{ $t('Change') }}</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import Tooltip from 'lightvue/tooltip';
import { formatDate } from '@/utils/dateUtils';
import { formatTime, convertDuration } from '@/utils/timeUtils';
import { getPriceWithMarkup, getTotalPriceWithMarkup } from '@/utils/priceUtils';
export default {
    name: "FlightMulitItem",
    directives: {
        tooltip: Tooltip,
    },
    props: [
        'item',
        'type',
        'result',
        'is_selected',
        'trusted_partners',
        'allowed_to_make_exception',
        'max_ticket_price',
        'is_self_paying',
        'user_type'
    ],
    data() {
        return {
            need_approval: false
        }
    },
    methods: {
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        getFormattedTime(timeString) {
            return formatTime(timeString);
        },
        convertDuration(duration) {
            return convertDuration(duration, this.$i18n.locale);
        },
        get_price_with_markup(ticketPrice) {
            return getPriceWithMarkup(ticketPrice, this.max_ticket_price);
        },
        get_total_price_with_markup(travelerPricings) {
            return getTotalPriceWithMarkup(travelerPricings, this.max_ticket_price);
        },
        select_flight() {
            this.need_approval = this.allowed_to_make_exception == 1 && this.get_price_with_markup(this.item.travelerPricings[0].price.total) > this.max_ticket_price;
            this.$emit('select_flight', this.item, this.type, this.need_approval);
        },
        change_flight() {
            this.$emit('change_flight', 'departure');
        }
    },
    mounted() {
        this.need_approval = this.allowed_to_make_exception == 1 && this.get_price_with_markup(this.item.travelerPricings[0].price.total) > this.max_ticket_price;
    }
};
</script>